import { render, staticRenderFns } from "./case_order_unresolved.vue?vue&type=template&id=3c4b2c2c"
import script from "./case_order_unresolved.vue?vue&type=script&lang=js"
export * from "./case_order_unresolved.vue?vue&type=script&lang=js"
import style0 from "./case_order_unresolved.vue?vue&type=style&index=0&id=3c4b2c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports